export default "__VITE_ASSET__CbB0S0FW__"